export default Object.freeze({
  POLICY_HOLDER_ACCESS: 'Policy Holder Access'.toLowerCase(),
  FULL_ACCESS: 'Full access'.toLowerCase(),
  SELF_ACCESS: 'Self access'.toLowerCase(),
  LIMITED_ACCESS: 'Limited access'.toLowerCase(),
  NO_ACCESS: 'No access'.toLowerCase(),
});
